import idx from 'idx'
import { connect } from 'react-redux'
import { compose, withStateHandlers } from 'recompose'

export default compose(
  connect((state) => {
    return {
      trap: idx(state, _ => _.traps.selected),
    }
  }),
  withStateHandlers(
    ({ timeValue = null }) => ({
      timeValue
    }),
    {
      onTimeChange: () => timeValue => ({
        timeValue
      }),
    }
  )
)



// WEBPACK FOOTER //
// ./src/components/organisms/TrapDetailsPopover/TrapDetailsPopover.enhancer.js